import { type MotionValue } from "motion/react";
import { FC, type PropsWithChildren } from "react";

import {
  DRAWER_MOTION_ENTER_DURATION_S,
  RIGHTBAR_DEFAULT_WIDTH,
  RIGHTBAR_DEFAULT_WIDTH_MOBILE,
  useIsMobile,
} from "@ryde/shared";

import { DrawerMotionWrapperStyled } from "./wrapper.styled";

interface IDrawerContainer extends PropsWithChildren {
  dataE2EName?: string;
  drawerWidth?: string | MotionValue<string>;
  skipCssEnter?: boolean;
  enterDurationSeconds?: number;
}

export const DrawerWrapper: FC<IDrawerContainer> = ({
  dataE2EName,
  drawerWidth,
  children,
  skipCssEnter = false,
  enterDurationSeconds = DRAWER_MOTION_ENTER_DURATION_S,
}) => {
  const { isMobile } = useIsMobile();
  const widthStyle = isMobile
    ? RIGHTBAR_DEFAULT_WIDTH_MOBILE
    : (drawerWidth ?? RIGHTBAR_DEFAULT_WIDTH);
  const stringWidth = typeof widthStyle === "string" ? widthStyle : undefined;
  const motionEnterProps = {
    initial: false as const,
    layout: false as const,
  };

  return (
    <DrawerMotionWrapperStyled
      $skipCssEnter={skipCssEnter}
      $enterDurationSeconds={enterDurationSeconds}
      custom={stringWidth}
      style={stringWidth ? undefined : { width: widthStyle }}
      data-e2e-name={dataE2EName}
      {...motionEnterProps}
    >
      {children}
    </DrawerMotionWrapperStyled>
  );
};
